import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllSpecialities = lazy(() => import("../pages/all-specialities"));

export const SpecialityManagementRouter = [
  {
    path: "/master-management/speciality",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllSpecialities />
          </Suspense>
        ),
      },
    ],
  },
];
